'use client';
import ErrorComponent from '@/components/Error';

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  return <ErrorComponent error={error} reset={reset} />;
}
